"use strict";
import { v4 } from "uuid";
import _ from "lodash";
export class Column {
  constructor(prop, options) {
    this.visible = true;
    this.prop = prop;
    this.options = options;
  }
  get component() {
    var _a;
    return (_a = this.options) == null ? void 0 : _a.component;
  }
  get label() {
    var _a;
    if ((_a = this.options) == null ? void 0 : _a.label) {
      return this.options.label;
    }
    return this.prop;
  }
  sort(sort) {
    var _a, _b;
    let _order = "desc";
    if (sort.order === "ascending") {
      _order = "asc";
    }
    if (sort.order === "descending") {
      _order = "desc";
    }
    if (typeof ((_a = this.options) == null ? void 0 : _a.sort) === "string") {
      return [this.options.sort, _order].join(",");
    }
    if (typeof ((_b = this.options) == null ? void 0 : _b.sort) === "boolean") {
      return [this.prop, _order].join(",");
    }
    return ["sort", _order].join(",");
  }
  get config() {
    var _a, _b, _c;
    const _config = {};
    if ((_a = this.options) == null ? void 0 : _a.sort) {
      _config.sortable = "custom";
    }
    if ((_b = this.options) == null ? void 0 : _b.width) {
      _config.width = this.options.width;
    }
    if ((_c = this.options) == null ? void 0 : _c.minWidth) {
      _config.minWidth = this.options.minWidth;
    }
    return _config;
  }
}
export class Columns extends Map {
  constructor(columns) {
    super();
    this._views = new Array();
    this._hash = v4();
    if (columns) {
      for (const _column of columns) {
        this.set(_column.prop, _column);
      }
    }
  }
  get hash() {
    return this._hash;
  }
  views(views = []) {
    this._views = views;
    this._hash = v4();
  }
  currentView() {
    return this._views;
  }
  columns() {
    const _columns = /* @__PURE__ */ new Map();
    const _views = _.orderBy(this._views, "sort");
    for (const _column of _views) {
      const _columnConfig = this.get(_column.name);
      if (_columnConfig) {
        _columnConfig.visible = _column.visible;
        _columns.set(_column.name, _columnConfig);
      }
    }
    return _columns;
  }
  use(prop) {
    return this.get(prop);
  }
  add(column, visible) {
    if (this.has(column.prop)) {
      return this;
    }
    this.set(column.prop, column);
    let _visible = true;
    if (visible && visible === "false") {
      _visible = false;
    }
    this._views.push({
      name: column.prop,
      visible: _visible
    });
  }
}
